module.exports = __webpack_public_path__ + "static/usage_submit2-1872deb73d0c7386285f2d297b8fa454.jpg";